// extracted by mini-css-extract-plugin
export var otherStuff = "Footer-module--otherStuff--2aTjm";
export var telephoneNumber = "Footer-module--telephoneNumber--e6r4V";
export var wrapper = "Footer-module--wrapper--3rx_3";
export var details = "Footer-module--details--3lFYI";
export var image = "Footer-module--image--1SSTI";
export var actions = "Footer-module--actions--3j2m3";
export var suffix = "Footer-module--suffix--3_3R_";
export var spacer = "Footer-module--spacer--yLrid";
export var social = "Footer-module--social--1XQ8o";